/** 候选能力屏（凭据 / 登录）：只有说明，不发业务请求，不收任何凭据，不做登录。 */

import { API_BASE } from "../../api/client";
import { useStatus } from "../../api/queries";
import { Card, Lede, Note, PageHead } from "../../components/Card";

export interface CandidateCopy {
  title: string;
  quote: string;
  reasons: string[];
}

export const CREDENTIALS_COPY: CandidateCopy = {
  title: "凭据（候选能力，未开卡）",
  quote: "凭据管理入口：在操作台查看凭据是否存在、连通测试与轮换记录，凭据值永不进界面。",
  reasons: [
    "单操作员、内网 / 本机部署，凭据只由部署者在机器上配置，界面没有必须查看凭据的场景。",
    "凭据值永不进界面：券商、数据源、托管的密钥一律走机队凭据管理，不进仓、不进操作台；界面最多给「是否存在」，而这件事尚无 Should 认领。",
    "真券商通道尚未接入（D4 实盘通道未裁决）；凭据治理本身（D10）也未裁决。",
  ],
};

export const LOGIN_COPY: CandidateCopy = {
  title: "登录 / 账户（候选能力，未开卡）",
  quote: "登录与会话：操作员登录、会话续期与多环境切换；单操作员内网部署下暂不需要。",
  reasons: [
    "单操作员、内网 / 本机部署：不设计注册、找回密码与权限矩阵，也不做公网暴露。",
    "危险动作的「谁做的」由表单里的 operator 与 reason 留痕，不依赖登录身份。",
    "凭据值永不进界面，本屏不收密码。",
  ],
};

export function CandidateScreen({ copy, showBackend }: { copy: CandidateCopy; showBackend?: boolean }): React.ReactNode {
  const status = useStatus();
  return (
    <>
      <PageHead title={copy.title} sub="候选能力 · 本屏不发业务请求" />
      <Lede>能力版图「候选能力（未开卡）」条目：{copy.quote}</Lede>
      <Card title="现阶段不做的原因">
        <ol>
          {copy.reasons.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ol>
      </Card>
      {showBackend ? (
        <Card title="当前连接的后端" sub="只读显示，不提供切换">
          <dl className="kv">
            <dt>地址</dt>
            <dd>{`${window.location.origin}${API_BASE}`}</dd>
            <dt>状态</dt>
            <dd>
              {status.isError
                ? "后端不可达（GET /status 失败）"
                : status.data
                  ? `可达 · 配置指纹 ${status.data.config_digest}`
                  : "检查中…"}
            </dd>
          </dl>
        </Card>
      ) : null}
      <Note>本屏不显示任何凭据名、来源或状态，也不提供登录、退出、续期或切换环境入口。</Note>
    </>
  );
}
